import { ReadingTimeStats } from '@models/shared/readingTimeStats.type.interface';
import { IStatusType } from '@models/shared/status.type.interface';

export class PriceGuide {
  _id?: string;
  id?: number;
  asCat?: number;
  title?: string;
  title_tag?: string; // SEO Meta
  meta_description?: string; // SEO Meta
  category?: string;
  categoryTitle?: string;
  imgUrl?: string;
  author?: string;
  status?: string;
  slug?: IStatusType;
  newSlug?: string;
  date?: string;
  publish_date?: string;
  price_guide?: { min?: number; middle?: number; max?: number };
  content?: any;
  main_category_title?: string;
  main_category_slug?: string;
  sub_header?: string;
  question?: string;
  answer?: string;
  shortExplanation?: string;
  mainCategory?: { slug: string };
  subCategory?: { slug: string };
  readingTimeStats?: ReadingTimeStats;
  imgAltAttribute?: string;
  heroImg?: string;
  viewCount?: number;
  constructor(data: any = null) {
    Object.assign(this, data);
  }
}
